import { render, staticRenderFns } from "./3-Store.vue?vue&type=template&id=5dc083f6&scoped=true"
import script from "./3-Store.vue?vue&type=script&lang=js"
export * from "./3-Store.vue?vue&type=script&lang=js"
import style0 from "./3-Store.vue?vue&type=style&index=0&id=5dc083f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc083f6",
  null
  
)

export default component.exports